import React from "react";
import { createStackNavigator, CardStyleInterpolators } from "@react-navigation/stack";

import LoginScreen from "../screens/LoginScreen";
import WelcomeScreen from "../screens/WelcomeScreen";
import ResetPasswordScreen from "../screens/ResetPasswordScreen";
import NewProductScreen from "../screens/NewProductScreen";
import DashboardScreen from "../screens/DashboardScreen";
import ProductDetailsScreen from "../screens/ProductDetailsScreen";
import AccountScreen from "../screens/AccountScreen";
import LocationDetailsScreen from "../screens/LocationDetailsScreen";
import NewUserScreen from "../screens/NewUserScreen";
import UserDetailsScreen from "../screens/UserDetailsScreen";
import UsersScreen from "../screens/UsersScreen";
import StoreScreen from "../screens/StoreScreen";
import ToolsScreen from "../screens/ToolsScreen";
import ChangePasswordScreen from "../screens/ChangePasswordScreen";
import DashboardScreenReskin from "../screens/DashboardScreenReskin";

const Stack = createStackNavigator();

const forFade = ({ current }) => ({
    cardStyle: {
        opacity: current.progress,
    },
});

const AppNavigator = () => (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
        <Stack.Screen name="Welcome" component={WelcomeScreen} />
        <Stack.Screen name="Login" component={LoginScreen} />
        <Stack.Screen name="Dashboard" component={DashboardScreen} />
        <Stack.Screen name="Store" component={StoreScreen} />
        <Stack.Screen name="ResetPassword" component={ResetPasswordScreen} />
        <Stack.Screen name="NewProduct" component={NewProductScreen} />
        <Stack.Screen name="ProductDetails" component={ProductDetailsScreen} />
        <Stack.Screen name="Account" component={AccountScreen} />
        <Stack.Screen name="Tools" component={ToolsScreen} />
        <Stack.Screen name="LocationDetails" component={LocationDetailsScreen} />
        <Stack.Screen name="NewUser" component={NewUserScreen} />
        <Stack.Screen name="UserDetails" component={UserDetailsScreen} />
        <Stack.Screen name="Users" component={UsersScreen} />
        <Stack.Screen name="ChangePassword" component={ChangePasswordScreen} />
        <Stack.Screen name="DashboardReskin" component={DashboardScreenReskin} />
    </Stack.Navigator>
);

export default AppNavigator;
